module.exports = __webpack_public_path__ + "img/DE03695.3528ef07.png";